import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RolePermissionService = {
  async getRoles(filterExpr) {
    // filterExpr is an OData $filter string or null for no filter
    return await ApiService.oDataGet({
      url: "api/Role",
      ...(filterExpr ? { filter: filterExpr } : {}),
    });
  },

  async getRoleTypes() {
    return await ApiService.oDataGet({ url: "api/ApplicationRoleType" });
  },

  async getLicenseTypes() {
    return await ApiService.oDataGet({ url: "api/ApplicationUserType" });
  },

  async getRoleById(roleId) {
    return await ApiService.get(`api/Role/${roleId}`);
  },

  async createRole(data) {
    ApiService.setHeaders();
    return await ApiService.post("api/Role", data);
  },

  async updateRole(roleId, data) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: `api/Role/${roleId}`,
      data,
    });
  },

  async deleteRole(roleId) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "delete",
      url: `api/Role/${roleId}`,
    });
  },

  async getRolePermissions(roleId, customerCode) {
    return await ApiService.get(
      `api/RolePermission/${roleId}?customerCode=${encodeURIComponent(
        customerCode,
      )}`,
    );
  },

  async saveRolePermissions(roleId, changes) {
    ApiService.setHeaders();
    return await ApiService.customRequest({
      method: "put",
      url: `api/RolePermission/${roleId}`,
      data: { Changes: changes },
    });
  },
};

export default RolePermissionService;
export { RolePermissionService };
